import styled, { css } from 'styled-components';
import getColorForStatus from '../helpers/getColorForStatus';
import { HealthScoreOverallStatus } from '../types';

export const InsightSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const InsightHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const InsightSectionTitle = styled.h2<{ $status: HealthScoreOverallStatus; $isOpen: boolean }>`
    font-size: 1.5rem;
    font-weight: 600;
    color: ${({ $status }) => getColorForStatus($status)};
    position: relative;
    max-width: fit-content;
    padding: 0 2rem;
    line-height: 1;

    &::after {
        position: absolute;
        right: 0;
        content: '';
        display: block;
        width: 1.5rem;
        top: 50%;
        transform-origin: right center;
        background-color: ${({ $status }) => getColorForStatus($status)};
        border-radius: 0.25rem;
        height: 0.25rem;
    }

    &::before {
        position: absolute;
        left: 0;
        content: '';
        display: block;
        width: 1.5rem;
        top: 50%;
        transform-origin: right center;
        background-color: ${({ $status }) => getColorForStatus($status)};
        border-radius: 0.25rem;
        height: 0.25rem;
    }
`;

export const InsightsContainer = styled.div<{ $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: 0;
    padding-top: 0;

    ${(props) => props.$isOpen && css`
        padding-top: 1rem;
        height: fit-content;
        margin-bottom: 1rem;
    `}
`;
